// Calls to the API Worker (SPEC.md §10) with the signed-in user's token.
import { supabase } from '../auth/supabase';

export const API_URL = import.meta.env.VITE_API_URL ?? 'https://api.getrenalflow.com';

export async function callApi<T>(path: '/checkout' | '/portal' | '/account/delete', body: Record<string, unknown> = {}): Promise<T> {
  if (!navigator.onLine) throw new Error('You’re offline. Connect to the internet and try again.');
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error('Sign in again to continue.');
  let response: Response;
  try {
    response = await fetch(`${API_URL}${path}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  } catch {
    throw new Error('RenalFlow’s server couldn’t be reached. Try again in a moment.');
  }
  const result = (await response.json().catch(() => ({}))) as T & { error?: string };
  if (!response.ok) throw new Error(result.error ?? `Something went wrong (${response.status}).`);
  return result;
}

export async function startCheckout(plan: 'yearly' | 'lifetime') {
  const { url } = await callApi<{ url: string }>('/checkout', { plan });
  window.location.assign(url);
}

export async function openPortal() {
  const { url } = await callApi<{ url: string }>('/portal');
  window.location.assign(url);
}
